import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export async function rosterGoogleClassroomClass(
  classId: string
): Promise<any> {
  const { data, error } = await supabase.functions.invoke(
    "rosterGoogleClassroomClass",
    {
      body: { classId },
    }
  );

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return {
      importedEmails: [],
      newImportedStudents: [],
      failedEmails: [],
      error: errorMessage.error,
    };
  }

  return {
    message: data?.message,
    importedCount: data?.importedCount ?? 0,
    importedEmails: data?.importedEmails ?? [],
    newImportedStudents: data?.newImportedStudents ?? [],
    failedEmails: data?.failedEmails ?? [],
    error: null,
  };
}
